import React from "react";
import { getAuth, isAuthValid } from "../security/authStorage";
import { Redirect, Route } from "react-router-dom";

// expected props
interface IProps {
  component: any;
  path: any;
}

class PrivateRoute extends React.Component<IProps, {}> {
  public render() {
    const loggedIn = isAuthValid(getAuth());

    //This copies all the properties from "this.props" but it renames "this.props.component" to "Component" so we can refer
    //to it that way below. The "...rest" means just copy the rest of the properties as-is.
    const { component: Component, ...rest } = this.props;

    //This is hard to read, but what its doing is:
    //1. Rendering a <Route /> and passing all props through to it.
    //2. If user is logged in, it returns whatever "Component" was passed in.
    //3. If not, it redirects to login page.
    return (
      <Route
        {...rest}
        render={(props) => (loggedIn ? <Component {...props} /> : <Redirect to={{ pathname: "/loginstart", state: { from: props.location } }} />)}
      />
    );
  }
}

export default PrivateRoute;
